var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __pow = Math.pow;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const VEHICLE_MAP_PREVIEW_STORAGE_KEY = "vehicle-map-preview-info";
function parseMapNodeList(raw) {
  if (!raw)
    return [];
  try {
    const parsed = JSON.parse(String(raw));
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
}
const CLASS_TIME_EARLY_GRACE_MIN = 10;
const CLASS_TIME_LATE_GRACE_MIN = 45;
const SHORT_SEGMENT_KM_FOR_SCHEDULE_PASS = 8;
const CLOSER_MARGIN_DEFAULT_M = 800;
const CLOSER_MARGIN_LATE_CLASS_M = 400;
function normalizeMapNodeGid(gid) {
  return String(gid != null ? gid : "").trim().toUpperCase();
}
function mergeMapArrivalWithQueryList(mapArrivals, queryArrivals) {
  const queryMap = /* @__PURE__ */ new Map();
  queryArrivals.forEach((item) => {
    const key = normalizeMapNodeGid(item.NodeGID || item.GID);
    if (key)
      queryMap.set(key, item);
  });
  return mapArrivals.map((mapNode) => {
    var _a;
    const query = queryMap.get(normalizeMapNodeGid(mapNode.GID));
    if (query) {
      if (query.IsCanSale === false)
        return null;
      if (query.HandheldManageIsShowThisNode === 0)
        return null;
      return __spreadProps(__spreadValues({}, mapNode), {
        GID: mapNode.GID || query.NodeGID || query.GID,
        NodeName: query.NodeName || mapNode.NodeName,
        Mileage: query.Mileage != null ? query.Mileage : mapNode.Mileage,
        RunTime: (_a = mapNode.RunTime) != null ? _a : query.RunTime,
        IsCanSale: query.IsCanSale,
        OrderByNo: query.OrderByNo,
        PredictOutTime: query.PredictOutTime
      });
    }
    return mapNode;
  }).filter((item) => !!item);
}
function buildOrderedMapStations(startNodes, arrivalNodes) {
  const tagged = [
    ...startNodes.map((node) => ({ node, role: "start" })),
    ...arrivalNodes.map((node) => ({ node, role: "arrival" }))
  ];
  const list = [];
  tagged.forEach(({ node, role }, index) => {
    var _a, _b;
    if (!node || !node.Geocoder)
      return;
    const geocoderArr = String(node.Geocoder).split(",");
    if (geocoderArr.length < 2)
      return;
    const nodeGid = normalizeMapNodeGid(node.GID);
    list.push({
      // GID 全局唯一，直接作站点 id（与 nodeGid 一致，便于选中/缓存键对齐）
      id: nodeGid || `${role}-${index}`,
      name: String(node.NodeName || "").replace(/\n/g, ""),
      role,
      kind: role === "arrival" ? "destination" : "origin",
      lng: Number(geocoderArr[0]),
      lat: Number(geocoderArr[1]),
      mileage: Number((_a = node.Mileage) != null ? _a : 0),
      runTime: Number((_b = node.RunTime) != null ? _b : 0),
      sequenceIndex: list.length,
      nodeGid,
      classTime: node.ClassTime ? String(node.ClassTime).trim() : void 0
    });
  });
  return list;
}
function parseStationClassTimeMs(station, classDate) {
  if (!station.classTime || !classDate)
    return void 0;
  const datePart = String(classDate).substring(0, 10);
  const time = String(station.classTime).trim();
  const combined = time.includes("-") ? time : `${datePart} ${time}`;
  const ms = Date.parse(combined.replace(/-/g, "/"));
  return Number.isFinite(ms) ? ms : void 0;
}
function resolveProgressNowMs(progress) {
  var _a;
  return (_a = progress == null ? void 0 : progress.nowMs) != null ? _a : Date.now();
}
function isClassTimeNotStartedYet(classTimeMs, nowMs) {
  if (classTimeMs == null)
    return false;
  return nowMs < classTimeMs - CLASS_TIME_EARLY_GRACE_MIN * 60 * 1e3;
}
function closerMarginForClassTime(classTimeMs, nowMs) {
  if (classTimeMs == null)
    return CLOSER_MARGIN_DEFAULT_M;
  if (nowMs > classTimeMs + CLASS_TIME_LATE_GRACE_MIN * 60 * 1e3)
    return CLOSER_MARGIN_LATE_CLASS_M;
  return CLOSER_MARGIN_DEFAULT_M;
}
function normalizeDepartPassedGids(gids) {
  return (gids != null ? gids : []).map((gid) => normalizeMapNodeGid(gid)).filter(Boolean);
}
function segmentMileageKm(orderedStations, index) {
  var _a, _b;
  if (index < 0 || index >= orderedStations.length - 1)
    return void 0;
  const curr = orderedStations[index];
  const next = orderedStations[index + 1];
  const currM = Number((_a = curr.mileage) != null ? _a : 0);
  const nextM = Number((_b = next.mileage) != null ? _b : 0);
  if (nextM > currM)
    return nextM - currM;
  return haversineDistanceM(curr, next) / 1e3;
}
function isStationPassedByLaterDepartRecords(index, orderedStations, departPassedNodeGids) {
  const passedSet = new Set(normalizeDepartPassedGids(departPassedNodeGids));
  if (!passedSet.size)
    return false;
  for (let j = index + 1; j < orderedStations.length; j++) {
    const later = orderedStations[j];
    if (later.role !== "start")
      continue;
    const key = normalizeMapNodeGid(later.nodeGid);
    if (key && passedSet.has(key))
      return true;
  }
  return false;
}
function isStationPassedByScheduleInference(orderedStations, index, progress) {
  var _a;
  const station = orderedStations[index];
  const nowMs = resolveProgressNowMs(progress);
  const classDate = progress == null ? void 0 : progress.classDate;
  const departGids = (_a = progress == null ? void 0 : progress.departPassedNodeGids) != null ? _a : [];
  if (isStationPassedByLaterDepartRecords(index, orderedStations, departGids))
    return true;
  if (index === 0 && station.role === "start") {
    const originClassMs = parseStationClassTimeMs(station, classDate);
    if (originClassMs != null && nowMs >= originClassMs)
      return true;
  }
  const classTimeMs = parseStationClassTimeMs(station, classDate);
  if (!classTimeMs)
    return false;
  const lateMs = CLASS_TIME_LATE_GRACE_MIN * 60 * 1e3;
  if (nowMs < classTimeMs + lateMs)
    return false;
  const segmentKm = segmentMileageKm(orderedStations, index);
  if (segmentKm == null)
    return false;
  return segmentKm <= SHORT_SEGMENT_KM_FOR_SCHEDULE_PASS;
}
function isStationSchedulePassed(orderedStations, index, progress) {
  return isStationPassedByScheduleInference(orderedStations, index, progress);
}
function findMapStationByNodeGid(stations, nodeGid) {
  var _a;
  const key = normalizeMapNodeGid(nodeGid);
  if (!key)
    return null;
  return (_a = stations.find((st) => normalizeMapNodeGid(st.nodeGid) === key)) != null ? _a : null;
}
function findNearestMapStation(pos, stations) {
  if (!stations.length)
    return null;
  let nearest = stations[0];
  let minD = Number.POSITIVE_INFINITY;
  for (const st of stations) {
    const d = haversineDistanceM(pos, st);
    if (d < minD) {
      minD = d;
      nearest = st;
    }
  }
  return nearest;
}
function haversineDistanceM(a, b) {
  const toRad = (d) => d * Math.PI / 180;
  const R = 6371e3;
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const lat1 = toRad(a.lat);
  const lat2 = toRad(b.lat);
  const h = __pow(Math.sin(dLat / 2), 2) + Math.cos(lat1) * Math.cos(lat2) * __pow(Math.sin(dLng / 2), 2);
  return 2 * R * Math.asin(Math.sqrt(h));
}
function hasPassedStationTowardNext(vehicle, curr, next) {
  const dCurr = haversineDistanceM(vehicle, curr);
  const dNext = haversineDistanceM(vehicle, next);
  const segment = haversineDistanceM(curr, next);
  if (segment <= 0)
    return dNext < dCurr;
  const onCorridor = dCurr + dNext <= segment * 1.35;
  if (!onCorridor)
    return false;
  return dNext < dCurr || dCurr > segment * 0.55;
}
function projectionProgressTowardTarget(vehicle, from, target) {
  const cosLat = Math.cos(from.lat * Math.PI / 180);
  const toXY = (p) => ({
    x: p.lng * 111320 * cosLat,
    y: p.lat * 110540
  });
  const V = toXY(vehicle);
  const A = toXY(from);
  const B = toXY(target);
  const dx = B.x - A.x;
  const dy = B.y - A.y;
  const len2 = dx * dx + dy * dy;
  if (len2 <= 0)
    return 0;
  return ((V.x - A.x) * dx + (V.y - A.y) * dy) / len2;
}
function hasDepartedStationTowardNext(vehicle, curr, next, passedThresholdM = 80, motion) {
  const dCurr = haversineDistanceM(vehicle, curr);
  const dNext = haversineDistanceM(vehicle, next);
  const segmentM = haversineDistanceM(curr, next);
  if (segmentM <= 0)
    return dNext < dCurr;
  if (dCurr + dNext > segmentM * 1.2)
    return false;
  if (dCurr < passedThresholdM)
    return false;
  const t = projectionProgressTowardTarget(vehicle, curr, next);
  const minDepartT = Math.max(500 / segmentM, 8e-3);
  if (dCurr >= passedThresholdM && t >= minDepartT && t <= 1.02)
    return true;
  if (dNext + 800 < dCurr)
    return true;
  const angle = typeof (motion == null ? void 0 : motion.angle) === "number" && !Number.isNaN(motion.angle) ? motion.angle : void 0;
  if (angle != null && t >= minDepartT) {
    const bearCurr = geoBearingToVehicleAngle(bearingDegrees(vehicle, curr));
    const bearNext = geoBearingToVehicleAngle(bearingDegrees(vehicle, next));
    const diffCurr = headingAngleDiff(angle, bearCurr);
    const diffNext = headingAngleDiff(angle, bearNext);
    if (diffCurr > 70 && diffNext + 15 < diffCurr)
      return true;
  }
  return false;
}
function isVehicleApproachingOnStationSegment(vehicle, from, to, corridorFactor = 1.2, progress) {
  const segmentM = haversineDistanceM(from, to);
  if (segmentM <= 0)
    return false;
  const dFrom = haversineDistanceM(vehicle, from);
  const dTo = haversineDistanceM(vehicle, to);
  if (dFrom + dTo > segmentM * corridorFactor)
    return false;
  const t = projectionProgressTowardTarget(vehicle, from, to);
  if (t < 0 || t >= 1)
    return false;
  const classTimeMs = to.classTime ? parseStationClassTimeMs(to, progress == null ? void 0 : progress.classDate) : void 0;
  const nowMs = resolveProgressNowMs(progress);
  if (isClassTimeNotStartedYet(classTimeMs, nowMs))
    return true;
  return true;
}
function hasReachedOrPassedStationOnSegment(vehicle, from, to, passedThresholdM = 80, progress) {
  const dTo = haversineDistanceM(vehicle, to);
  if (dTo < passedThresholdM)
    return true;
  const classTimeMs = to.classTime ? parseStationClassTimeMs(to, progress == null ? void 0 : progress.classDate) : void 0;
  const nowMs = resolveProgressNowMs(progress);
  if (isClassTimeNotStartedYet(classTimeMs, nowMs))
    return false;
  if (isVehicleApproachingOnStationSegment(vehicle, from, to, 1.2, progress))
    return false;
  const segmentM = haversineDistanceM(from, to);
  if (segmentM <= 0)
    return false;
  const dFrom = haversineDistanceM(vehicle, from);
  if (dFrom + dTo > segmentM * 1.2)
    return false;
  const t = projectionProgressTowardTarget(vehicle, from, to);
  if (dTo <= Math.max(1500, segmentM * 0.03) && t >= 0.88)
    return true;
  if (classTimeMs != null) {
    const lateMs = CLASS_TIME_LATE_GRACE_MIN * 60 * 1e3;
    const segmentKm = segmentM / 1e3;
    if (nowMs > classTimeMs + lateMs && segmentKm <= SHORT_SEGMENT_KM_FOR_SCHEDULE_PASS && t >= 0.75 && dTo <= Math.max(2e3, segmentM * 0.05)) {
      return true;
    }
  }
  return t > 1.02;
}
function isStationSkippedForEtaWaypoints(vehicle, orderedStations, index, targetIdx, passedThresholdM = 80, options) {
  var _a, _b, _c;
  const departGids = (_c = (_b = options == null ? void 0 : options.departPassedNodeGids) != null ? _b : (_a = options == null ? void 0 : options.progress) == null ? void 0 : _a.departPassedNodeGids) != null ? _c : [];
  const planningOptions = {
    motion: options == null ? void 0 : options.motion,
    departPassedNodeGids: departGids,
    progress: options == null ? void 0 : options.progress
  };
  if (isStationPassedForPlanning(vehicle, orderedStations, index, passedThresholdM, planningOptions))
    return true;
  if (isStationPassedByLaterDepartRecords(index, orderedStations, departGids))
    return true;
  if (isStationPassedForEtaWaypoint(vehicle, orderedStations, index, targetIdx))
    return true;
  const station = orderedStations[index];
  const nodeKey = normalizeMapNodeGid(station.nodeGid);
  if (nodeKey && normalizeDepartPassedGids(departGids).includes(nodeKey))
    return true;
  if (index < orderedStations.length - 1) {
    const next = orderedStations[index + 1];
    if (hasDepartedStationTowardNext(vehicle, station, next, passedThresholdM, options == null ? void 0 : options.motion))
      return true;
  }
  return false;
}
function isStationPassedForEtaWaypoint(vehicle, orderedStations, index, targetIdx) {
  if (index < 0 || index >= targetIdx)
    return false;
  const curr = orderedStations[index];
  const target = orderedStations[targetIdx];
  const segmentM = haversineDistanceM(curr, target);
  if (segmentM <= 0)
    return false;
  const dCurr = haversineDistanceM(vehicle, curr);
  const dTarget = haversineDistanceM(vehicle, target);
  if (dCurr + dTarget > segmentM * 1.2)
    return false;
  const t = projectionProgressTowardTarget(vehicle, curr, target);
  const minProgress = Math.max(3e3 / segmentM, 0.025);
  return t >= minProgress && t <= 1.08;
}
function isStationPassedAlongRoute(vehicle, orderedStations, index, passedThresholdM = 80, options) {
  var _a;
  if (index < 0 || index >= orderedStations.length)
    return false;
  const curr = orderedStations[index];
  const dCurr = haversineDistanceM(vehicle, curr);
  if (dCurr < passedThresholdM)
    return true;
  const nowMs = resolveProgressNowMs(options == null ? void 0 : options.progress);
  const classTimeMs = parseStationClassTimeMs(curr, (_a = options == null ? void 0 : options.progress) == null ? void 0 : _a.classDate);
  const classNotStarted = isClassTimeNotStartedYet(classTimeMs, nowMs);
  if (!classNotStarted) {
    const closerMargin = closerMarginForClassTime(classTimeMs, nowMs);
    for (let j = index + 1; j < orderedStations.length; j++) {
      const dLater = haversineDistanceM(vehicle, orderedStations[j]);
      if (dLater + closerMargin < dCurr)
        return true;
    }
  }
  if (index < orderedStations.length - 1 && !classNotStarted) {
    const next = orderedStations[index + 1];
    if (hasPassedStationTowardNext(vehicle, curr, next))
      return true;
  }
  return false;
}
function isStationPassedForPlanning(vehicle, orderedStations, index, passedThresholdM = 80, options) {
  var _a, _b, _c;
  const station = orderedStations[index];
  const departGids = (_c = (_b = options == null ? void 0 : options.departPassedNodeGids) != null ? _b : (_a = options == null ? void 0 : options.progress) == null ? void 0 : _a.departPassedNodeGids) != null ? _c : [];
  const progress = __spreadProps(__spreadValues({}, options == null ? void 0 : options.progress), {
    departPassedNodeGids: departGids
  });
  const nodeKey = normalizeMapNodeGid(station.nodeGid);
  if (nodeKey && normalizeDepartPassedGids(departGids).includes(nodeKey))
    return true;
  if (isStationPassedByScheduleInference(orderedStations, index, progress))
    return true;
  return isStationPassedAlongRoute(
    vehicle,
    orderedStations,
    index,
    passedThresholdM,
    {
      motion: options == null ? void 0 : options.motion,
      progress
    }
  );
}
function resolveNextStationByRoute(vehicle, orderedStations, passedThresholdM = 80, progress) {
  if (!orderedStations.length)
    return null;
  for (let i = 0; i < orderedStations.length; i++) {
    if (isStationPassedForPlanning(vehicle, orderedStations, i, passedThresholdM, {
      progress
    })) {
      continue;
    }
    return orderedStations[i];
  }
  return orderedStations[orderedStations.length - 1];
}
function bearingDegrees(from, to) {
  const toRad = (d) => d * Math.PI / 180;
  const toDeg = (r) => r * 180 / Math.PI;
  const lat1 = toRad(from.lat);
  const lat2 = toRad(to.lat);
  const dLng = toRad(to.lng - from.lng);
  const y = Math.sin(dLng) * Math.cos(lat2);
  const x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLng);
  return (toDeg(Math.atan2(y, x)) + 360) % 360;
}
function headingAngleDiff(a, b) {
  const d = Math.abs(((a - b) % 360 + 360) % 360);
  return d > 180 ? 360 - d : d;
}
function geoBearingToVehicleAngle(geoBearingNorth0) {
  return (geoBearingNorth0 - 90 + 360) % 360;
}
function hasVehiclePassedStationByRoute(vehicle, targetStation, orderedStations, passedThresholdM = 80, motion, progress) {
  var _a, _b;
  const targetIdx = orderedStations.findIndex((st) => st.id === targetStation.id);
  if (targetIdx < 0)
    return false;
  const dTarget = haversineDistanceM(vehicle, targetStation);
  if (dTarget < passedThresholdM)
    return true;
  for (let i = targetIdx + 1; i < orderedStations.length; i++) {
    if (haversineDistanceM(vehicle, orderedStations[i]) < passedThresholdM)
      return true;
  }
  const departGids = (_a = progress == null ? void 0 : progress.departPassedNodeGids) != null ? _a : [];
  if (isStationPassedByScheduleInference(orderedStations, targetIdx, __spreadProps(__spreadValues({}, progress), {
    departPassedNodeGids: departGids
  }))) {
    return true;
  }
  const nowMs = resolveProgressNowMs(progress);
  const classTimeMs = parseStationClassTimeMs(targetStation, progress == null ? void 0 : progress.classDate);
  if (isClassTimeNotStartedYet(classTimeMs, nowMs))
    return false;
  const angle = typeof (motion == null ? void 0 : motion.angle) === "number" && !Number.isNaN(motion.angle) ? motion.angle : void 0;
  const speed = Number((_b = motion == null ? void 0 : motion.speed) != null ? _b : 0);
  if (targetIdx < orderedStations.length - 1) {
    const nextSt = orderedStations[targetIdx + 1];
    if (hasDepartedStationTowardNext(vehicle, targetStation, nextSt, passedThresholdM, motion))
      return true;
  }
  if (angle != null && targetIdx < orderedStations.length - 1) {
    const nextSt = orderedStations[targetIdx + 1];
    if (hasPassedStationTowardNext(vehicle, targetStation, nextSt)) {
      const bearToTarget = geoBearingToVehicleAngle(bearingDegrees(vehicle, targetStation));
      const bearToNext = geoBearingToVehicleAngle(bearingDegrees(vehicle, nextSt));
      const diffTarget = headingAngleDiff(angle, bearToTarget);
      const diffNext = headingAngleDiff(angle, bearToNext);
      if (diffTarget > 90 && diffNext + 15 < diffTarget && (speed >= 3 || diffTarget > 120))
        return true;
    }
  }
  const next = resolveNextStationByRoute(vehicle, orderedStations, passedThresholdM, progress);
  if (!next)
    return false;
  const nextIdx = orderedStations.findIndex((st) => st.id === next.id);
  if (nextIdx <= targetIdx)
    return false;
  const NEAR_NEXT_STATION_M = 2e3;
  if (haversineDistanceM(vehicle, next) < NEAR_NEXT_STATION_M)
    return true;
  if (angle != null && targetIdx < orderedStations.length - 1) {
    const nextSt = orderedStations[targetIdx + 1];
    if (!hasPassedStationTowardNext(vehicle, targetStation, nextSt))
      return false;
    const bearToTarget = geoBearingToVehicleAngle(bearingDegrees(vehicle, targetStation));
    if (headingAngleDiff(angle, bearToTarget) > 90)
      return true;
  }
  return false;
}
function buildEtaRoutePointsToStation(vehicle, targetStation, orderedStations, passedThresholdM = 80, options) {
  var _a, _b;
  const targetIdx = orderedStations.findIndex((st) => st.id === targetStation.id);
  if (targetIdx < 0)
    return [vehicle, { lng: targetStation.lng, lat: targetStation.lat }];
  const departPassed = (_b = (_a = options == null ? void 0 : options.departPassedNodeGids) != null ? _a : options == null ? void 0 : options.extraPassedNodeGids) != null ? _b : [];
  const progress = __spreadProps(__spreadValues({}, options == null ? void 0 : options.progress), {
    departPassedNodeGids: departPassed
  });
  const planningOptions = {
    motion: options == null ? void 0 : options.motion,
    departPassedNodeGids: departPassed,
    progress
  };
  let fromIdx = targetIdx;
  for (let i = 0; i <= targetIdx; i++) {
    if (isStationSkippedForEtaWaypoints(
      vehicle,
      orderedStations,
      i,
      targetIdx,
      passedThresholdM,
      planningOptions
    )) {
      continue;
    }
    fromIdx = i;
    break;
  }
  const points = [
    { lng: vehicle.lng, lat: vehicle.lat }
  ];
  for (let i = fromIdx; i <= targetIdx; i++) {
    const st = orderedStations[i];
    points.push({ lng: st.lng, lat: st.lat });
  }
  return points;
}
function estimateRouteChainDistanceM(points) {
  let total = 0;
  for (let i = 0; i < points.length - 1; i++)
    total += haversineDistanceM(points[i], points[i + 1]);
  return total;
}
function findVehicleStationDepartRecord(records, vehicleGid, nodeGid) {
  var _a;
  const nKey = normalizeMapNodeGid(nodeGid);
  if (!nKey || !records.length)
    return null;
  const vKey = String(vehicleGid != null ? vehicleGid : "").trim().toUpperCase();
  const sameVehicle = (r) => {
    var _a2;
    const rGid = String((_a2 = r.VehicleGID) != null ? _a2 : "").trim().toUpperCase();
    return vKey && rGid && rGid === vKey;
  };
  return (_a = records.find((r) => {
    if (!sameVehicle(r))
      return false;
    return normalizeMapNodeGid(r.StartNodeGID) === nKey;
  })) != null ? _a : null;
}
function isVehicleArrivedAtStationByDepartRecord(records, vehicleGid, nodeGid) {
  const record = findVehicleStationDepartRecord(records, vehicleGid, nodeGid);
  if (!record)
    return false;
  return !!(record.SignInOperTime || record.StartCarTime);
}
function isVehiclePassedStationByLaterDepartRecords(records, orderedStations, vehicleGid, targetStation) {
  var _a, _b;
  if (!targetStation || !orderedStations.length)
    return false;
  const targetIdx = orderedStations.findIndex((st) => st.id === targetStation.id);
  if (targetIdx < 0)
    return false;
  const departGids = [];
  const vKey = String(vehicleGid != null ? vehicleGid : "").trim().toUpperCase();
  for (const r of records) {
    if (!(r.SignInOperTime || r.StartCarTime))
      continue;
    const rGid = String((_a = r.VehicleGID) != null ? _a : "").trim().toUpperCase();
    if (vKey && rGid && rGid !== vKey)
      continue;
    const nodeGid = String((_b = r.StartNodeGID) != null ? _b : "").trim();
    if (nodeGid)
      departGids.push(nodeGid);
  }
  return isStationPassedByLaterDepartRecords(targetIdx, orderedStations, departGids);
}
function wgs84ToGcj02(lng, lat) {
  const a = 6378245;
  const ee = 0.006693421622965943;
  function transformLat(x, y) {
    let ret = -100 + 2 * x + 3 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
    ret += (20 * Math.sin(6 * x * Math.PI) + 20 * Math.sin(2 * x * Math.PI)) * 2 / 3;
    ret += (20 * Math.sin(y * Math.PI) + 40 * Math.sin(y / 3 * Math.PI)) * 2 / 3;
    ret += (160 * Math.sin(y / 12 * Math.PI) + 320 * Math.sin(y * Math.PI / 30)) * 2 / 3;
    return ret;
  }
  function transformLng(x, y) {
    let ret = 300 + x + 2 * y + 0.1 * x * x + 0.3 * x * y + 0.2 * Math.sqrt(Math.abs(x));
    ret += (20 * Math.sin(6 * x * Math.PI) + 20 * Math.sin(2 * x * Math.PI)) * 2 / 3;
    ret += (20 * Math.sin(x * Math.PI) + 40 * Math.sin(x / 3 * Math.PI)) * 2 / 3;
    ret += (150 * Math.sin(x / 12 * Math.PI) + 300 * Math.sin(x / 30 * Math.PI)) * 2 / 3;
    return ret;
  }
  let dLat = transformLat(lng - 105, lat - 35);
  let dLng = transformLng(lng - 105, lat - 35);
  const radLat = lat / 180 * Math.PI;
  let magic = Math.sin(radLat);
  magic = 1 - ee * magic * magic;
  const sqrtMagic = Math.sqrt(magic);
  dLat = dLat * 180 / (a * (1 - ee) / (magic * sqrtMagic) * Math.PI);
  dLng = dLng * 180 / (a / sqrtMagic * Math.cos(radLat) * Math.PI);
  return { lng: lng + dLng, lat: lat + dLat };
}
function normalizeGpsPosition(item) {
  const lng = Number(item.Lon);
  const lat = Number(item.Lat);
  if (!Number.isFinite(lng) || !Number.isFinite(lat))
    return void 0;
  const code = (item.CoordTypeCode || "GCJ02").toUpperCase();
  if (code === "GCJ02")
    return { lng, lat };
  if (code === "WGS84")
    return wgs84ToGcj02(lng, lat);
  return { lng, lat };
}
export {
  VEHICLE_MAP_PREVIEW_STORAGE_KEY,
  bearingDegrees,
  haversineDistanceM,
  buildEtaRoutePointsToStation,
  buildOrderedMapStations,
  estimateRouteChainDistanceM,
  findMapStationByNodeGid,
  findNearestMapStation,
  findVehicleStationDepartRecord,
  geoBearingToVehicleAngle,
  hasReachedOrPassedStationOnSegment,
  hasVehiclePassedStationByRoute,
  headingAngleDiff,
  isStationPassedByLaterDepartRecords,
  isStationPassedForPlanning,
  isStationSchedulePassed,
  isVehicleApproachingOnStationSegment,
  isVehicleArrivedAtStationByDepartRecord,
  isVehiclePassedStationByLaterDepartRecords,
  mergeMapArrivalWithQueryList,
  normalizeGpsPosition,
  normalizeMapNodeGid,
  parseMapNodeList,
  parseStationClassTimeMs,
  resolveNextStationByRoute
};
